import { DialogContent, Typography, Zoom } from "@material-ui/core"
import AppContext from "contexts/App"
import PropTypes from "prop-types"
import { useContext } from "react"

import useStyles from "./styles"

const Submitted = ({ data, fromSuper }) => {
  const classes = useStyles()
  const { authUser } = useContext(AppContext)
  return (
    <DialogContent>
      <Typography color="primary" variant="h4" className={classes.title}>
        {fromSuper
          ? "CSV import has been completed"
          : "CSV uploaded, MatchBoard staff will review it and enter the information."}
      </Typography>
    </DialogContent>
  )
}

Submitted.propTypes = {
  data: PropTypes.object,
  fromSuper: PropTypes.bool,
}

export default Submitted
